(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/campaign-image.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/campaign-image.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  campaign: {
    openCampaignApi
  },
  productMapping
} = svs.numbergames;
const {
  imageTypes
} = svs.numbergames.picasso.setup;
const {
  getMultiImageOptions
} = svs.numbergames.picasso.image_multi;
let animateImage = true;
svs.numbergames.game.views.CampaignImage = Marionette.View.extend({
  ui: {
    campaignImg: '.js-campaign-img'
  },
  events: {
    'click @ui.campaignImg': 'onCampaignImgClicked'
  },
  className() {
    const classNames = ['ng-campaign-image-container col-xs-12 col-sm-10 col-sm-offset-1 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2'];
    animateImage && classNames.push('animate-image');
    return classNames.join(' ');
  },
  getTemplate() {
    return this.campaignImages ? svs.numbergames.game.templates.campaign_image : false;
  },
  templateContext() {
    var _this$campaignImages, _this$campaignImages2;
    const productCampaignId = productMapping.getProductCampaignId(this.model.get('productId'));
    return _objectSpread({
      href: svs.core.urlMapping.get("".concat(productCampaignId, "_ExtraChances_OngoingBet"))
    }, getMultiImageOptions((_this$campaignImages = this.campaignImages) === null || _this$campaignImages === void 0 ? void 0 : _this$campaignImages.largeImageUrl, imageTypes.campaignDesktop, (_this$campaignImages2 = this.campaignImages) === null || _this$campaignImages2 === void 0 ? void 0 : _this$campaignImages2.smallImageUrl, imageTypes.campaignMobile));
  },
  initialize() {
    this.campaignImages = openCampaignApi.getCampaignImages(this.model.get('productId'));
  },
  onRender() {
    animateImage = false;
  },
  onCampaignImgClicked() {
    svs.components.analytics.trackEvent({
      category: 'campaign',
      action: 'campaign_picture_click',
      opt_label: productMapping.getBrandingClass(this.model.get('productId'))
    });
  }
});

 })(window);